import { Form, useSchemaForm } from "@/components/form";
import { Stack, StackProps, Typography } from "@mui/material";
import { useEffect } from "react";
import { z } from "zod/v4";

const articuloPrecioGenFormSchema = z.object({
    precioPer: z.array(z.number().min(0, "El valor debe ser mayor a 0")).length(3)
})

interface ArticuloPrecioGenFormProps extends Omit<StackProps, "onSubmit"> {
    costo: number,
    defaultPercentage: {
        precio1Per: number,
        precio2Per: number,
        precio3Per: number
    },
    onSubmit: (precios: number[]) => any
}

export default function ArticuloPrecioGenForm({
    costo,
    defaultPercentage: { precio1Per, precio2Per, precio3Per },
    onSubmit,
    ...props
}: ArticuloPrecioGenFormProps) {
    const form = useSchemaForm({
        schema: articuloPrecioGenFormSchema,
        onSubmit: ({ value }) => {
            const [precio1Per, precio2Per, precio3Per] = articuloPrecioGenFormSchema.parse(value).precioPer;
            const precio1 = costo + costo * precio1Per / 100;
            const precio2 = precio1 - precio1 * precio2Per / 100;
            const precio3 = precio1 - precio1 * precio3Per / 100;
            onSubmit([precio1, precio2, precio3])
        },
        defaultValues: {
            precioPer: [precio1Per, precio2Per, precio3Per],
        } as z.infer<typeof articuloPrecioGenFormSchema>,
        closeModalOnSubmit: true,
        submitOnce: true,
    })

    useEffect(() => {
        form.focusField("precioPer[0]")
    }, [])

    return <Form {...props} form={form} gap={3}>
        <PricePercentageInput name="precioPer[0]" label="Precio 1" text="sobre el Costo." />
        <PricePercentageInput name="precioPer[1]" label="Precio 2" text="descontado del Precio 1." />
        <PricePercentageInput name="precioPer[2]" label="Precio 3" text="descontado del Precio 1." />
        <Form.SubmitButton>Generar</Form.SubmitButton>
    </Form>
}

function PricePercentageInput({ name, label, text, }: { name: string, label: string, text?: string, }) {
    return <Stack direction={"row"} alignItems={"center"} gap={1}>
        <Stack width={"75px"}>
            <Form.NumberField alignRight size="small" name={name} label={label}
                slotProps={{ input: { endAdornment: "%" } }}
            />
        </Stack>
        <Typography>{text}</Typography>
    </Stack>
}
